// import ApplicationTitle from '../../components/ApplicationTitle';
import TextInput from '../../components/input_fields/TextInput';
import TwoInputs from '../../components/input_fields/TwoInputs'
// import FormTitle from '../../components/form_titles/FormTitle';
import DoubleButton from '../../components/buttons/DoubleButton';
// import ThreeInputs from '../../components/input_fields/ThreeInputs';
import ProgressBar from '../../components/progress/ProgressBar';

import validator from "validator";
import React, { useState } from "react";
import { data } from '../../constants';
import FormTextStack from '../../components/form_titles/FormTextStack';
import ThreeInputsSearch from '../../components/input_fields/seachable/ThreeInputsSearch';


export default function Step7({ nextStep, handleFormData, prevStep, values, validation, color }) {

  // Required
  const [princNameError, setPrincNameError] = useState(false)
  const [princSSNError, setPrincSSNError] = useState(false)
  const [princTitleError, setPrincTitleError] = useState(false)
  const [princOwnershipError, setPrincOwnershipError] = useState(false)
  const [princStreetError, setPrincStreetError] = useState(false)
  const [princDOBError, setPrincDOBError] = useState(false)
  const [princCityError, setPrincCityError] = useState(false)
  const [princStateError, setPrincStateError] = useState(false)
  const [princZipError, setPrincZipError] = useState(false)

  // Not Required
  // const [princStreet2Error, setPrincStreet2Error] = useState(false)

  const submitFormData = async (e) => {

    e.preventDefault()

    if (validation) {
      // Principal Name Error
      if (validator.isEmpty(values.princName)) {
        setPrincNameError(true)
        return
      } setPrincNameError(false)

      // Principal SSN Error
      if (!values.princSSN.match(/^\d{3}-?\d{2}-?\d{4}$/)) {
        setPrincSSNError(true)
        return
      } setPrincSSNError(false)

      // Principal Title Error
      if (validator.isEmpty(values.princTitle)) {
        setPrincTitleError(true)
        return
      } setPrincTitleError(false)

      // Principal Ownership Error
      if (!validator.isNumeric(values.princOwnership) || values.princOwnership < 25) {
        setPrincOwnershipError(true)
        return
      } setPrincOwnershipError(false)

      // Principal Street Error
      if (validator.isEmpty(values.princStreet)) {
        setPrincStreetError(true)
        return
      } setPrincStreetError(false)

      // Principal Date of Birth
      if (!values.princDOB.match(/(\d{4}(\/|-)\d{1,2}(\/|-)\d{1,2})/)) {
        setPrincDOBError(true)
        return
      } setPrincDOBError(false)

      // Principal City Error
      if (validator.isEmpty(values.princCity)) {
        setPrincCityError(true)
        return
      } setPrincCityError(false)

      // Principal State Error
      if (!data.states.includes(values.princState)) {
        setPrincStateError(true)
        return
      } setPrincStateError(false)

      // Principal Zip Error
      if (!validator.isNumeric(values.princZip) || values.princZip.length !== 5) {
        setPrincZipError(true)
        return
      } setPrincZipError(false)

    }
    nextStep()
  }

  return (
    <div className="bg-white-900 dark:bg-white-900">
      <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
        <ProgressBar
          progress="84%"
          color = {color}
        />
        <div className="bg-white rounded-lg shadow dark:border width-screen xl:p-0">
          <div className="p-6 space-y-1 sm:p-8">
            <FormTextStack
              color = {color}
              mainTitle="You're"
              colorTitle="almost there!"
              lines={["Tell us who is the authorized officer/signatory for the business.", "(Must be an officer or controller of a private corporation,"]}
              lastLine="member LLC, individual or sole proprietorship with at least 25% ownership)"
              modalTitle="Principal Beneficial Owner Info"
              modalDesc="According to the 2001 U.S. Patriot Act, providing your social security number and home address is required when opening a merchant services account. It helps ensure identities are protected and protects against illicit activities."
            />
            <form className="space-y-4" onSubmit={submitFormData}>
              <TwoInputs
                color = {color}
                placeholder1="Principal's Full name" id1="name" type1="text" name1="princName" value1={values.princName}
                error1={princNameError} message1={"Please provide the Principal's Name."}
                handleInputChange1={handleFormData}
                placeholder2="Principal's SSN" id2="ssn" type2="text" name2="princSSN" value2={values.princSSN}
                error2={princSSNError} message2={"Format: AAA-GG-SSSS"}
                handleInputChange2={handleFormData}
              />

              <TwoInputs
                color = {color}
                placeholder1="Principal's Title" id1="title" type1="text" name1="princTitle" value1={values.princTitle}
                error1={princTitleError} message1={"Please provide the Principal's Title."}
                handleInputChange1={handleFormData}
                placeholder2="Principal's Ownership in Company %" name2="princOwnership" id2="ownership" type2="text" value2={values.princOwnership}
                error2={princOwnershipError} message2={"Provide ownership in % (Just type the number must be over 25%)"}
                handleInputChange2={handleFormData}

              />
              <TwoInputs
                color = {color}
                placeholder1="Principal's Street Address" id1="street" name1="princStreet" type1="text" value1={values.princStreet}
                error1={princStreetError} message1={"Provide a street address."}
                handleInputChange1={handleFormData}
                placeholder2="Address Line 2" id2="street2" type2="text" name2="princAddr"
                handleInputChange2={handleFormData}
              />

              <TextInput 
                color = {color}
                placeholder="Principal's Date of Birth (yyyy-mm-dd)" id="dob" name="princDOB" value2={values.princDOB}
                error={princDOBError} message={"Provide a valid date. (yyyy-mm-dd)"}
                handleInputChange={handleFormData} 
              />

              <ThreeInputsSearch
                color = {color}
                placeholder1="City" id1="city" type1="text" name1="princCity" value1={values.princCity}
                error1={princCityError} message1={"Provide a city."}
                handleInputChange1={handleFormData}
                placeholder2="State" id2="state" type2="text" name2="princState" value2={values.princState}
                error2={princStateError} message2={"Provide a state."}
                handleInputChange2={handleFormData}
                placeholder3="Zipcode" id3="zip" type3="text" name3="princZip" value3={values.princZip}
                error3={princZipError} message3={"Please a 5 digit zipcode."}
                handleInputChange3={handleFormData}
              />

              <DoubleButton color = {color} prevStep={prevStep} />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}